import React, { useCallback, useEffect, useMemo, useState } from 'react'
import KapalService from '../../../../services/kapal/KapalService'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { FaPlus } from 'react-icons/fa'
import DataTable from 'react-data-table-component'

const MasterKapal = () => {

    const columns = [
        {
            name: 'Nama Kapal',
            cell: row => row['namaKapal']
        },
        {
            name: 'Ukuran Kapal',
            cell: row => row['ukuranKapal']
        },
        {
            name: 'Pemilik',
            cell: row => row['pemilik']
        },
        {
            name: 'NIB',
            cell: row => row['nib']
        },
        {
            name: 'Penanggung Jawab',
            cell: row => row['penanggungJawab']
        },
        {
            name: 'Jumlah ABK',
            cell: row => row['jumlahAbk']
        },
        {
            name: 'Action',
            cell: row => (
                <>
                </>
            )
        }
    ]

    let kapalService = useMemo(() => new KapalService(), [])
    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const [valueSearchNmKapal, setValueSearchNmKapal] = useState(null)
    const onChangeValueSearchNmKapal = e => {
        setValueSearchNmKapal(e.target.value)
    }

    const handleClickReset = () => {
        setValueSearchNmKapal('')
        getMasterKapal(0, 10, null)
    }

    const getMasterKapal = useCallback(async (page, size, namaKapal = null, kodeTrader = 0) => {
        setLoading(true)
        try {
            let response
            if (localStorage.getItem("kodeTrader") !== null) {
                response = await kapalService.listMasterKapal(page, size, namaKapal, localStorage.getItem("kodeTrader"))
            } else {
                response = await kapalService.listMasterKapal(page, size, namaKapal, kodeTrader)
            }
            setListData(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            setListData([])
        }
        setLoading(false)
    }, [kapalService])

    useEffect(() => {
        getMasterKapal(0, 10, valueSearchNmKapal)
    }, [getMasterKapal, valueSearchNmKapal])

    const handleChangePage = (page) => {
        getMasterKapal(page - 1, size, valueSearchNmKapal)
    }

    const handlePerRowsChange = async (size, page) => {
        getMasterKapal(page - 1, size, valueSearchNmKapal)
        setSize(size)
    }

    const handleClickCari = () => {
        getMasterKapal(0, 10, valueSearchNmKapal)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-6">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nama Kapal" className="form-control-sm" value={valueSearchNmKapal} onChange={onChangeValueSearchNmKapal} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari()}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Master Kapal</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Button type="button" variant="primary" size="sm"><FaPlus /> Tambah</Button>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default MasterKapal